export const englishLabels = {
    COMMON_LABELS: {
        TOP_TITLE: 'Authentication Package MSSO',
        EMAIL_LABEL: 'Email',
        SINGLE_LOGOUT_SUCCESS_MESSAGE: 'Successfully Single Logged Out!',
        SUBMIT_BUTTON: 'Login',
    },
    LOGIN: {
        REGISTRATION_LINK: 'registration-none',
        REGISTRATION_DESCRIPTION: 'Need an account?',
        MAIN_TITLE: 'Sign in',
        FORGOT_PASSWORD_LINK: 'Forgot your password?',
    },
    REGISTRATION: {},
    FORGOT_PASSWORD: {
        MAIN_TITLE: 'Forgot your password?',
        FORGOT_PASSWORD_MESSAGE: 'Enter the email address associated with your account.',
        EMAIL_PLACEHOLDER: 'Enter your email address',
        SENT_LINK_EMAIL_MESSAGE: 'We just sent you an email to reset your password.',
        INTERNAL_FAILURE_MESSAGE: 'We were unable to process your request, please try again.',
    },
    SESSION_TIMEOUT: {
        HEADER: 'Still Working?',
        EXPIRE_MESSAGE: 'Your session will expire soon',
        MINUTES: 'min',
        SECONDS: 'sec',
        INSTRUCTION_MESSAGE:
            "We noticed you haven't taken any actions recently. Keep your work by selecting an option below.",
        CONTINUE_BUTTON: 'Continue my session',
        LOGOUT_BUTTON: 'Sign out',
    },
};
